<template>
  <div class="rodemap">
    <div class="sharetip" v-if="share" @click="share = false">
      <div class="s"></div>
    </div>
    <img
      class="save-img"
      src="https://cdn.original-fun.com/gugong/和男神在一起-s.jpg"
    />
    <div class="result-btn-area">
      <div class="btn-next" @click="jumpToNext"></div>
      <div class="btn-share" @click="share = true"></div>
      <div class="txt">长按 “公告天下” 保存图片</div>
    </div>
  </div>
</template>

<script>
//script
import Tools from '../../../scripts/tools';
import { gsap } from 'gsap';
//Global
import Global from '../../../scripts/Global';
import WordDialog from '../../cmp/wordDialog';

export default {
  data() {
    return {
      share: false,
      index: 0,
      arr: [
        {
          headImg: 'cv-03',
          word:
            '御景亭在整个御花园东侧的假山顶上。原是明代观花殿的旧址，万历间改堆假山。御景亭是皇帝、皇后重阳节登高的地方，亭上可俯瞰宫苑，远眺紫禁城、景山，整个西苑尽在目中。',
        },
      ],
    };
  },
  components: {
    WordDialog,
  },
  created() {},
  computed: {},
  methods: {
    jump(event) {
      this.index += 1;
      if (this.arr.length === this.index) {
        this.index--;
      }
    },
    jumpToNext() {
      this.$router.replace('/rodemap/aj/07');
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.rodemap {
  //   background-image: url(//cdn.original-fun.com/gugong/男神嫌弃分享图2.jpg);
  background-position: center;
  width: 100vw;
  height: 100vh;
  max-width: 75vh;
  margin: 0 auto;
  overflow: hidden;
  background-size: cover;
  background-repeat: no-repeat;
}

.save-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0;
}
.result-btn-area {
  bottom: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 5;
  background-image: url(//cdn.original-fun.com/tmp/gg/15.jpg);
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: cover;
  pointer-events: none;

  .btn-next {
    position: absolute;
    bottom: 2rem;
    height: 20%;
    width: 48%;
    pointer-events: all;
  }
  .btn-share {
    pointer-events: none;
  }
  .txt {
    position: absolute;
    text-align: center;
    width: 100%;
    bottom: 1rem;
    font-size: 12px;
  }
}
.btn-next,
.btn-share {
  width: 3.3rem;
  height: 1rem;
}
</style>
